import { IManager, createManager } from '@ms/telemetry-manager/lib/Manager';
import { asOnceOnly } from '../../store/middleware/RunOnceMiddleware';
import { IItemCacheDispatch, IItemCacheThunkAction } from '../../store/actions/ItemCacheActions';
import { telemetryHandlersConfigurationFacet } from '../../facets/TelemetryFacets';
import { loggerFacet } from '../../facets/LoggerFacets';
import { IClonedEvent } from '@ms/telemetry-manager/lib/IClonedEvent';
import { Qos, IQosEndSchema } from '@ms/telemetry-manager/lib/events/Qos.event';
import { ClonedEventType } from '@ms/telemetry-manager/lib/EventBase';
import { CorrelationVector } from '@ms/telemetry-manager/lib/CorrelationVector';
import { Engagement } from '@ms/telemetry-manager/lib/events/Engagement.event';
import { readConfiguration } from '../configuration/readConfiguration';

export const getTelemetryManager: IItemCacheThunkAction<IManager> = asOnceOnly(
  (dispatch: IItemCacheDispatch) => {
    const manager = createManager();

    const {
      telemetryHandlers = [],
      logger
    } = dispatch(readConfiguration({
      telemetryHandlers: telemetryHandlersConfigurationFacet,
      logger: loggerFacet
    }));

    for (const handler of telemetryHandlers) {
      handler.attach(manager);
    }

    const logQosData = logger && logger.logQoSData;

    const logEngagementData = logger && logger.logEngagementData;

    if (logQosData) {
      const endMap = new WeakMap<CorrelationVector, (data: IQosEndSchema) => void>();

      manager.addLogHandler((clonedEvent: IClonedEvent): void => {
        if (Qos.isTypeOf(clonedEvent)) {
          if (clonedEvent.eventType === ClonedEventType.End) {
            const endQos = endMap.get(clonedEvent.vector);

            if (endQos) {
              endQos(clonedEvent.data);
            }
          } else if (clonedEvent.eventType === ClonedEventType.Start) {
            endMap.set(clonedEvent.vector, logQosData(clonedEvent.data, clonedEvent.context));
          }
        }
      });
    }

    if (logEngagementData) {
      manager.addLogHandler((clonedEvent: IClonedEvent): void => {
        if (Engagement.isTypeOf(clonedEvent)) {
          if (clonedEvent.eventType === ClonedEventType.Single) {
            logEngagementData(clonedEvent.data, clonedEvent.context);
          }
        }
      });
    }

    return manager;
  }
);
